module.exports = __webpack_public_path__ + "static/media/smart_reco.bcdb61a2.svg";